import React, { useState, useEffect } from "react";
import Slider from "../../components/Slider/Slider";
import Navbar from "../../components/Navbar/Navbar";
import { Images } from "../../assets/assets";

const Header = ({
  title,
  textBackground,
  backgroundImg,
  isHalf,
  subTitle,
  desktopHeight, 
  mobileHeight,
  desktopTextMargin,
  mobileTextMargin,
  desktopTitleMargin,
  mobileTitleMargin
}: {
  title?: string;
  subTitle?: string;
  textBackground?: string;
  isHalf?: boolean;
  backgroundImg?: string;
  desktopHeight?: string; 
  mobileHeight?: string;
  desktopTextMargin?: string;
  mobileTextMargin?: string;
  desktopTitleMargin?: string;
  mobileTitleMargin?: string;
}) => {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  return (
    <div className="mt-[165px] md:mt-0">
       <div className="block md:hidden">
        <Navbar />
      </div>
      <div
        style={{
          height: screenSize.width >= 1060 ? desktopHeight || "70vh" : mobileHeight || "",
          backgroundImage: `url(${backgroundImg || Images.StoreLocatorBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="mb-0 overflow-hidden"
      >
        <div className="hidden md:block absolute z-50 top-0 left-0 w-full">
          <Navbar />
        </div>

        <Slider images={[backgroundImg || Images.StoreLocatorBg]} />

        <div className="overflow-hidden whitespace-nowrap">
          <p
            style={{
              marginTop: screenSize.width > 1060 
                ? (desktopTextMargin || "1%") 
                : (mobileTextMargin || "-35%"),
            }}
            className="w-auto md:w-[90px] absolute top-45 md:top-1/4 left-4 text-left
             font-black text-[45px] md:text-[140px] md:leading-[95px] tracking-normal text-[#75A7AD] 
             uppercase opacity-40 font-dm-sans z-0"
          >
            {textBackground}
          </p>
        </div>

        <div className="absolute md:z-20 top-40 md:top-0 md:left-0 w-full">
          <div className="md:mt-[200px] ml-[10%] flex flex-col">
            <h1
              style={{
                marginTop: screenSize.width > 1060 
                  ? (desktopTitleMargin || "0%") 
                  : (mobileTitleMargin || "17%"),
              }}
              className="text-left text-[23px] md:text-[40px] tracking-normal text-white 
              opacity-100 font-bold ml-[-5%]"
            >
              {title}
            </h1>

            <p
              style={{ marginTop: "10%" }}
              className="text-left text-[15px] md:text-[20px] tracking-normal text-white opacity-100 font-semibold"
            >
              {subTitle}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;